// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading_loading-btns__S8\\+xh {
  padding: 14px;
  animation: loading_spin__X9Z3Q 0.4s linear 0s infinite;
  display: inline-block;
  border-radius: 50%;
  border-left: 2px solid #fff;
  width: 10px !important;
  height: 10px !important;
}

.loading_loading-page__8m1qT {
  padding: 30px;
  animation: loading_spin__X9Z3Q 0.4s linear 0s infinite;
  display: inline-block;
  border-radius: 50%;
  border-left: 4.5px dotted #e1b964;
}

.loading_sceleton__Gcuu3 {
  width: 100%;
  height: 100vh;
}
.loading_sceleton-inner__tW9g5 {
  max-width: 1200px;
  margin: auto;
}
.loading_sceleton-row__j3\\+fY {
}
@keyframes loading_spin__X9Z3Q {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
.loading_icon__Yhf1g {
  width: 2rem !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/loading/loading.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sDAAuC;EACvC,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sDAAuC;EACvC,qBAAqB;EACrB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;AACA;AACA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,sBAAsB;AACxB","sourcesContent":[".loading-btns {\n  padding: 14px;\n  animation: spin 0.4s linear 0s infinite;\n  display: inline-block;\n  border-radius: 50%;\n  border-left: 2px solid #fff;\n  width: 10px !important;\n  height: 10px !important;\n}\n\n.loading-page {\n  padding: 30px;\n  animation: spin 0.4s linear 0s infinite;\n  display: inline-block;\n  border-radius: 50%;\n  border-left: 4.5px dotted #e1b964;\n}\n\n.sceleton {\n  width: 100%;\n  height: 100vh;\n}\n.sceleton-inner {\n  max-width: 1200px;\n  margin: auto;\n}\n.sceleton-row {\n}\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n.icon {\n  width: 2rem !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading-btns": `loading_loading-btns__S8+xh`,
	"spin": `loading_spin__X9Z3Q`,
	"loading-page": `loading_loading-page__8m1qT`,
	"sceleton": `loading_sceleton__Gcuu3`,
	"sceleton-inner": `loading_sceleton-inner__tW9g5`,
	"sceleton-row": `loading_sceleton-row__j3+fY`,
	"icon": `loading_icon__Yhf1g`
};
export default ___CSS_LOADER_EXPORT___;
